var React = require('react');

function Port (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0V0z","fill":"none","key":0}),React.createElement("path",{"d":"M18.8 20.2c-1.3 0-2.5-.4-3.6-1.2-2.2 1.6-5.1 1.6-7.3 0-1.1.8-2.4 1.2-3.6 1.2H2.4V22h1.8c1.3 0 2.5-.3 3.6-.9 2.3 1.2 5 1.2 7.3 0 1.1.6 2.4.9 3.6.9h1.8v-1.8h-1.7zM4.2 18.4c1.5 0 2.8-.8 3.7-1.8.9 1 2.2 1.8 3.6 1.8s2.7-.8 3.6-1.8c.9 1 2.2 1.8 3.6 1.8l1.2-5.2c.1-.2.1-.5-.1-.7-.1-.2-.3-.4-.5-.5l-.7-.2V7.6c0-.7-.6-1.3-1.3-1.3H17V4.9c0-.7-.6-1.3-1.3-1.3h-2.6v-1c.2-.3-.1-.6-.4-.6h-2.4c-.3 0-.6.3-.6.6v1H7.1c-.7 0-1.3.6-1.3 1.3v1.4h-.3c-.7 0-1.3.6-1.3 1.3v4.2l-.7.2c-.2.1-.4.2-.5.5-.1.2-.1.5 0 .7l1.2 5.2zM6 8.1h.3c.7 0 1.3-.6 1.3-1.3V5.4h7.7v1.4c0 .7.6 1.3 1.3 1.3h.4v3l-5.4-1.9-5.6 2V8.1z","key":1})]);
}

Port.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Port;

Port.default = Port;
